import React, { useState, useContext } from 'react';
import { RxCross2 } from 'react-icons/rx';
import ModalHeading from '../../components/shared/modal-heading';
import { AccountsContext } from '../../components/context/account-context';
import { updateNote } from '../../services/notes-service';
import EditableField from '../../components/shared/editable-input';

const EditModal = ({
    selectedRow,
    setSelectedRow,
    setIsEditModalOpen,
    setData
}) => {
    const { accountId } = useContext(AccountsContext);
    const [loading, setLoading] = useState(false);
    const [apiResponse, setApiResponse] = useState({ message: '', type: '' });

    const handleFieldUpdate = async (value, fieldName) => {
        setLoading(true);
        setApiResponse({ message: '', type: '' });

        try {
            const response = await updateNote(accountId, selectedRow.noteId, { note: value });

            if (response.success) {
                const updatedRow = {
                    ...selectedRow,
                    note: value
                };
                setSelectedRow(updatedRow)
                setData(prevData => prevData.map(row =>
                    row.noteId === selectedRow.noteId ? updatedRow : row
                ));
                setApiResponse({ message: 'Note updated successfully!', type: 'success' });
                setTimeout(() => setIsEditModalOpen(false), 1000);
            } else {
                setApiResponse({
                    message: response.data.message || 'Failed to update note',
                    type: 'error'
                });
                // throw new Error(response.data.message || 'Failed to update note');
            }
        } catch (error) {
            setApiResponse({
                message: error.message || 'An unexpected error occurred',
                type: 'error'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="space-y-3 px-4 pt-3 relative">
            <ModalHeading className="text-left mb-3">Edit Note</ModalHeading>

            <button
                type="button"
                className="absolute -top-3 -right-2 bg-white border p-2 rounded-full hover:scale-105 transition"
                onClick={() => setIsEditModalOpen(false)}
                disabled={loading}
            >
                <RxCross2 className="text-xl" />
            </button>

            {apiResponse.message && (
                <div className={`px-4 py-2 text-sm rounded-md mx-4 ${apiResponse.type === 'success'
                    ? 'text-green-600 bg-green-100'
                    : 'text-red-600 bg-red-100'
                    }`}>
                    {apiResponse.message}
                </div>
            )}

            <EditableField
                label="Note"
                name="note"
                type="textarea"
                rows={4}
                value={selectedRow?.note || ''}
                onChange={handleFieldUpdate}
                isLoading={loading}
                className="min-h-[120px]"
            />
        </div>
    );
};

export default EditModal;